export default function UpdatesSection() {
  const updates = [
    {
      id: 1,
      time: '10分钟前',
      title: '某女星被拍到素颜现身机场，与精修图差距引热议',
      tag: '最新',
      tagColor: 'accent',
    },
    {
      id: 2,
      time: '28分钟前',
      title: '知名导演深夜发文暗讽某流量明星演技，网友猜测对象',
      tag: '热议',
      tagColor: 'accent',
    },
    {
      id: 3,
      time: '1小时前',
      title: '某选秀冠军被前经纪人爆料拖欠分成，双方各执一词',
      tag: '跟进',
      tagColor: 'primary',
    },
    {
      id: 4,
      time: '2小时前',
      title: '三大视频平台同步下架某争议艺人全部作品',
      tag: '突发',
      tagColor: 'accent',
    },
    {
      id: 5,
      time: '3小时前',
      title: '某综艺节目录制现场发生意外，制作组紧急叫停',
      tag: '快讯',
      tagColor: 'primary',
    },
    {
      id: 6,
      time: '5小时前',
      title: '知名博主爆料某品牌质量门事件，品牌方尚未回应',
      tag: '待核实',
      tagColor: 'secondary',
    },
    {
      id: 7,
      time: '7小时前',
      title: '今晨狗仔队拍到某顶流与好友深夜聚餐至凌晨',
      tag: '八卦',
      tagColor: 'secondary',
    },
    {
      id: 8,
      time: '9小时前',
      title: '某音乐节后台打架事件新进展：当事人已公开道歉',
      tag: '更新',
      tagColor: 'primary',
    },
  ];

  const tagColorMap: Record<string, string> = {
    accent: 'bg-accent-100/20 text-accent-400 border-accent-300/20',
    primary: 'bg-primary-100/20 text-primary-400 border-primary-300/20',
    secondary: 'bg-secondary-100/20 text-secondary-400 border-secondary-300/20',
  };

  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-400 bg-primary-100/15 px-3 py-1 rounded-full mb-4 whitespace-nowrap">
            <i className="ri-flashlight-line"></i>
            Live Updates
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500">实时追踪今日黑料最新进展，分秒不落</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200"></div>

          <div className="space-y-4">
            {updates.map((update) => (
              <div key={update.id} className="relative flex items-start gap-5 pl-12">
                <div className={`absolute left-[11px] top-1.5 w-4 h-4 rounded-full border-2 flex-shrink-0 ${
                  update.tagColor === 'accent'
                    ? 'bg-accent-500 border-accent-500'
                    : update.tagColor === 'primary'
                    ? 'bg-primary-500 border-primary-500'
                    : 'bg-secondary-500 border-secondary-500'
                }`}></div>

                <div className="flex-1 min-w-0 bg-background-100 border border-background-200/60 rounded-lg p-4 hover:border-background-300/60 transition-all cursor-pointer">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs text-foreground-600 whitespace-nowrap">{update.time}</span>
                    <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-semibold border whitespace-nowrap ${tagColorMap[update.tagColor]}`}>
                      {update.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-200 leading-snug">
                    {update.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}